import { useContext, useEffect } from "react";
import { LayoutContext } from "../layout-context-container";
import styles from './_captcha.module.scss';
import Button from "../button";

export default function Captcha() {
  const { captchKey } = useContext(LayoutContext);

  useEffect(() => {
    if (captchKey) {
      // Load the reCAPTCHA script dynamically
      let script = null;

      if (!document.getElementById('recaptcha-script')) {
        script = document.createElement('script');
        script.id = 'recaptcha-script';
        script.src = `https://www.google.com/recaptcha/api.js?render=${captchKey}`;
        document.head.appendChild(script);
      }

      return () => {
        // Cleanup: remove script when component unmounts
        if (script && document.head.contains(script)) {
          document.head.removeChild(script);
        }
      };
    }
  }, [captchKey]);

  const getCaptchaToken = async () => {
    // execute reCAPTCHA and get the token
    let captchaToken = undefined;
    if (window['grecaptcha']) {
      await window['grecaptcha'].execute(captchKey, { action: 'submit' })
        .then((token) => {
          // You can use the token here, e.g., send it to your server
          captchaToken = token;
        })
        .catch((error) => {
          console.error('reCAPTCHA error:', error);
          throw {name: error.name, message: error.message, type: 'CAPTCHA_LOAD_ERROR'};
        });
    } else {
      console.error('reCAPTCHA error: Script not loaded properly.');
      const error = new Error('reCAPTCHA script not loaded properly.');
      throw {name: error.name, message: error.message, type: 'CAPTCHA_LOAD_ERROR'};
    }

    return captchaToken;
  }

  const CaptchaErrorMessage = ({ invalid = false, customClass = undefined }) => {
    return (
      <>
        {invalid && <div className={`captcha-error ${styles.captcha_error}` + (customClass ? ` ${customClass}` : '')}>
          There was an error with reCAPTCHA. Please try again.
        </div>} 
      </>
    );
  };

  const CaptchaDisclaimer = () => {
    return (
      <div className={`captcha-disclaimer ${styles.captcha_disclaimer}`}>
        This site is protected by reCAPTCHA and the Google <Button
          customClass="captcha-button !underline text-hcp-eggplant"
          targetBlank
          leaveSiteLink
          data-gtm-event-category="Form"
          data-gtm-event-action="Click"
          data-gtm-event-label="Privacy Policy"
          href="https://policies.google.com/privacy">Privacy Policy</Button> and <Button
            customClass="captcha-button !underline text-hcp-eggplant"
            targetBlank
            leaveSiteLink
            data-gtm-event-category="Form"
            data-gtm-event-action="Click"
            data-gtm-event-label="Terms of Service"
            href="https://policies.google.com/terms">Terms of Service</Button> apply
      </div>
    );
  };

  return {
    getCaptchaToken,
    CaptchaDisclaimer,
    CaptchaErrorMessage
  };
}